(ns kyber.lib.error-reporting
  (:require [re-frame.core :as re-frame]
            [goog.object :as gobj]

            [kyber.constants :as c]))

(defn before-send
  [^js report]
  (let [{:keys [sub email given-name family-name groups]
         :or {groups #{}}}
        @(re-frame/subscribe [:authentication/user-attributes])]

    (when (some? c/partner-name)
      (.updateMetaData report
                       "app-data"
                       (clj->js {:partner-name c/partner-name})))

    (when (some? sub)
      (gobj/set report
                "user"
                (clj->js {:id sub
                          :name (str family-name
                                     ", "
                                     given-name)
                          :email email
                          :roles groups})))))

(defn ->failed-request-error
  ([event-name] (->failed-request-error event-name {}))
  ([event-name metadata]
   {:name (str "Failed Network Request - " (name event-name))
    :tab-name "network"
    :payload (assoc metadata :event-name event-name)}))

(defn notify
  ([bugsnag-client error]
   (notify bugsnag-client error {}))
  ([^js bugsnag-client error options]
   (.notify bugsnag-client error (clj->js options))))
